import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { ActionButton } from "src/library/components/Button";

interface SupportTicketActionListProps {
  ticketId: number;
  context?: "drop" | "support"
}

export const SupportTicketActionList = (props: SupportTicketActionListProps) => {
  const history = useHistory();

  const goToTicket = useCallback(() => {
    let path = "";

    switch (props.context) {
      case "drop":
        path = `tickets/${props.ticketId}`;
        break;
      case "support":
        path = `/support/tickets/${props.ticketId}`;
        break;
      default:
        path = `/support/tickets/${props.ticketId}`;
    }

    return [
      {
        title: "View",
        action: () => {
          history.push(path);
        },
        newTabPath: path
      }
    ];
  }, [
    history,
    props.context,
    props.ticketId
  ]);

  return (
    <ActionButton
      title="Actions"
      items={[ ...goToTicket() ]}
    />
  );
};